import { useLanguage } from "@/context/LanguageContext";

export const Ticker = () => {
  const { t } = useLanguage();
  const items = [...t.ticker, ...t.ticker];
  return (
    <div className="marquee relative overflow-hidden border-y border-[var(--line)] bg-[var(--bg-2)] py-4" aria-hidden="true">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[var(--bg-2)] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[var(--bg-2)] to-transparent" />
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="inline-flex items-center gap-10 font-mono text-xs uppercase tracking-[0.2em] text-[var(--ink-2)]">
            {item}
            <span className="h-1 w-1 rounded-full bg-[var(--olive-2)]" />
          </span>
        ))}
      </div>
    </div>
  );
};
